import { render, staticRenderFns } from "./BeneficiaryFixedBenefits.vue?vue&type=template&id=3b6a1c4f&scoped=true"
import script from "./fixed_benefits.js?vue&type=script&lang=js&external"
export * from "./fixed_benefits.js?vue&type=script&lang=js&external"
import style0 from "./BeneficiaryFixedBenefits.vue?vue&type=style&index=0&id=3b6a1c4f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6a1c4f",
  null
  
)

export default component.exports